import { MODEL_COLORS } from "../../../util/constants";
import { featureConversion } from "../../analysis/util/analysisUtils";
import * as R from "rambda";


export const getModelPlotData = (modelResults, features, units, id, isClusterData) => {
    let plotData = [];

    features.forEach((item) => {
        const data = R.path(
            ["result", id, item.id, "data"],
            modelResults
        );

        const missing = R.path(
            ["result", id, item.id, "missing"],
            modelResults
        );

        const dates = R.path(
            ["result", id, item.id, "dates"],
            modelResults
        );

        const unitSymbol = R.path(
            ["result", id, item.id, "unit", "symbol"],
            modelResults
        );

        // Skip if no data
        if (!data || !dates) return;

        // Get count of non-null values for marker sizing
        const filtered_missing = data?.map((d, idx) => missing[idx] ? null : (d && d !== null && !isNaN(d)) ? d.toFixed(3) : d)
        const count = filtered_missing.filter(x => x !== null).length;

        // Create the main trace with continuous line
        const mainTrace = {
            id: id,
            y: filtered_missing,
            x: dates,
            symbol: unitSymbol,
            name: item.name,
            featureName: item.name,
            hovertemplate: `%{y}(${unitSymbol})`,
            type: "scatter",
            showlegend: true,
            mode: "lines+markers",
            marker: {
                size: count > 10 ? 3 : 8,
                color: data?.map((d, idx) => {
                    if (isClusterData && isClusterData[idx] === 1) {
                        return 'darkblue';
                    } else {
                        return MODEL_COLORS[item.name];
                    }
                }),
            },
            line: {
                color: MODEL_COLORS[item.name],
            },
        };

        plotData.push(mainTrace);


        const hasCluster = isClusterData && isClusterData.some(val => val === 1);


        if (hasCluster) {
            // Add a legend-only trace for cluster points
            const clusterLegend = {
                x: [null],
                y: [null],
                name: `${item.name} - Cluster`,
                mode: 'markers',
                marker: {
                    color: 'darkblue',
                    size: count > 10 ? 5 : 8,
                },
                showlegend: true,
                hoverinfo: 'none',

            };
            plotData.push(clusterLegend);
        }
    });

    return plotData;
}



export const includesIgnoreCase = (arr, target) => {
    return arr.some(item => item.toLowerCase() === target.toLowerCase());
};